import React, { Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import cn from 'classnames'

const Styled = withStyles(theme =>
  theme.components.scorecard.ScorecardView.ScorecardScroller.ScorecardFixedColumn.ScorecardMainHeader(
    theme
  )
)

export default Styled(props => {
  const {
    classes,
    collapsed,
    gridData: {
      normHeaders: { header_metrics }
    }
  } = props
  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="flex-start"
      className={classes.container}
      color="inherit"
    >
      <Grid item className={cn(classes.headerGrid, classes.top)}>
        <Typography variant="caption" color="inherit">Ad Code</Typography>
      </Grid>
      <Grid item className={cn(classes.headerGrid)}>
        <Typography noWrap variant="caption" color="inherit">
          Title
        </Typography>
      </Grid>
      <Grid item className={classes.headerGrid}>
        <Typography noWrap variant="caption" color="inherit">
          Last Month Tested
        </Typography>
      </Grid>
      {collapsed ? null : (
        <Fragment>
          <Grid className={classes.headerGrid} item>
            <Typography variant="caption" color="inherit">Ad Length</Typography>
          </Grid>
          <Grid className={classes.headerGrid} item>
            <Typography variant="caption" color="inherit">Sample Size</Typography>
          </Grid>
          <Grid className={classes.headerGrid} item>
            <Typography variant="caption" color="inherit">LTD Spend</Typography>
          </Grid>
          <Grid className={classes.headerGrid} item>
            <Typography variant="caption" color="inherit">Days in Market</Typography>
          </Grid>
          <Grid className={classes.headerGrid} item>
            <Typography variant="caption" color="inherit">Recall Efficiency</Typography>
          </Grid>
        </Fragment>
      )}
      {header_metrics.map(header_metric => (
        <Grid item className={cn(classes.headerGrid)} key={header_metric.label}>
          <Typography
            noWrap
            variant="caption" color="inherit"
            align="center"
            className={classes.headerMetric}
          >
            {header_metric.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  )
})



// WEBPACK FOOTER //
// ./src/app/configuration/FidelityV2/config/components/scorecard/ScorecardView/ScorecardScroller/ScorecardMainHeader.js